import { useContext, useEffect, useState } from 'react'

import { LocaleContext, MeasurLocale } from '../locale/i18n'
import { ISlugLink } from '../locale/pathing'

export const lastLocaleHintKey = 'lastLocaleHint'

const useFinnishLocaleHint = ({
  showLocaleHint = true,
  localisedSlugs,
}: {
  showLocaleHint: boolean
  localisedSlugs: ISlugLink[]
}) => {
  const [showFinnishLocaleHint, setShowFinnishLocaleHint] =
    useState<boolean>(false)
  const { locale } = useContext(LocaleContext)

  useEffect(() => {
    try {
      const lastHint = parseInt(
        localStorage.getItem(lastLocaleHintKey) ?? '0',
        10,
      )
      if (isNaN(lastHint)) {
        localStorage.removeItem(lastLocaleHintKey)
        setShowFinnishLocaleHint(true)
        return
      }
      if (lastHint + 604800000 < Date.now()) {
        // one week cooldown
        setShowFinnishLocaleHint(true)
      }
    } catch {
      // safe to ignore as e.g. android webview requires enabling storage api
    }
  }, [])

  return {
    showFinnishLocaleHint:
      showLocaleHint &&
      showFinnishLocaleHint &&
      locale !== MeasurLocale.FINLAND_FINNISH &&
      localisedSlugs.some(ls => ls.locale === MeasurLocale.FINLAND_FINNISH) &&
      navigator.languages.some(lang => /^(fi-|^fi$)/i.test(lang)),
    storeShowFinnishLocaleHint: (show: boolean) => {
      setShowFinnishLocaleHint(show)
      try {
        if (show) {
          localStorage.removeItem(lastLocaleHintKey)
        } else {
          localStorage.setItem(lastLocaleHintKey, Date.now().toString())
        }
      } catch {
        // safe to ignore as e.g. android webview requires enabling storage api
      }
    },
  }
}

export default useFinnishLocaleHint
